import { format } from 'date-fns'

export function time({ time, language }: { time: string; language: string }) {
  if (time === '' || !time) return
  const datetime = new Date(time)
  const jpDate = format(datetime, 'yyyy年MM月dd日')
  const enDate = format(datetime, 'MM/dd/yyyy')
  if (language === 'en') {
    return enDate
  }
  return jpDate
}

export function formatTimeWithHour({ time }: { time: string }) {
  if (!time) return ''
  const datetime = new Date(time)
  return format(datetime, 'yyyy/MM/dd HH:mm')
}
